import React from 'react';
import { Box, Container, Typography, Button, Stack } from '@mui/material';
import { Link } from 'react-router-dom';

import Toolbar from '../../components/Toolbar/Toolbar';
import Footer from '../../components/Footer/Footer';
import Logout from '../../containers/Login/Logout';

export default function About() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* top bar */}
      <Toolbar button={<Logout />} />

      {/* main content */}
      <Container maxWidth="md" sx={{ py: 6, flex: 1 }}>
        <Typography variant="h4" gutterBottom>
          About Cryptologics-AI
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          Cryptologics-AI is a workspace for building and running systematic crypto strategies. You can
          define clear, rule-based entries and exits, test them on historical data, and then apply the
          same rules in live trading.
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          A central focus is <strong>low-latency decision making</strong> — keeping the time between a
          market change and a trading decision as short as possible. The long-term goal is to reach
          <strong> HFT-grade</strong> responsiveness so that many strategies can operate at once without
          getting in each other’s way.
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          The result is a platform aimed at traders who want consistency: the strategy they design is the
          strategy that runs, with controls for risk and visibility into what the system is doing.
        </Typography>

        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            component={Link}
            to="/profile/traderform"
          >
            Create a Strategy
          </Button>
          <Button
            variant="outlined"
            component={Link}
            to="/profile/portfolio"
          >
            View Portfolio
          </Button>
        </Stack>
      </Container>

      {/* footer */}
      <Footer />
    </Box>
  );
}
